<!-- @format -->

<ng-container *transloco="let t">
  @if (
    {
      isLoading: this.loading$ | async,
      enrolmentsData: enrolmentsData$ | async,
      isMobileView: isMobileView$ | async,
      events: enrolmentDataChangeEvents$ | async,
    };
    as data
  ) {
    <div class="container sis-pt-md">
      @if (!!data.enrolmentsData) {
        <sis-breadcrumbs></sis-breadcrumbs>
        <sis-page-title [title]="t('ENROLMENTS.PAGE_TITLE')" [showCrumbs]="true" />
        @if (!!data.enrolmentsData) {
          <app-teaching-not-selected [enrolments]="this.enrolments"></app-teaching-not-selected>
        }
        <div class="row sis-mt-lg">
          <div class="col-sm-8 col-12">
            <h2>{{ t("ENROLMENTS.ENROL_TO_CUR_TITLE") }}</h2>
          </div>
          <div class="col-sm-4 col-12 sis-mb-xs refresh-button-container">
            <sis-button
              (clicked)="this.updateButtonClicked()"
              [hollow]="true"
              [label]="t('ENROLMENTS.UPDATE_BUTTON')"
              [size]="'sm'"
              class="float-end"></sis-button>
            <span #updateStatus aria-live="off" class="visually-hidden">
              {{ data.isLoading ? t("ENROLMENTS.LOADING_TEXT") : t("ENROLMENTS.LOADED_TEXT") }}
            </span>
          </div>
          <div aria-live="polite" id="enrolment-data-change-notification-area">
            @if (data.events?.length > 0 && !data.isLoading) {
              <div data-cy="enrolment-data-change-notifications" class="col-12">
                <sis-contextual-notification variant="warning">
                  <p>{{ "ENROLMENT_DATA_CHANGE.NOTIFICATION.GENERIC_CHANGES_TEXT" | translate }}</p>
                  <ul>
                    @for (enrolmentDataChange of data.events; track enrolmentDataChange) {
                      @if (this.getEnrolmentChangeDescription(enrolmentDataChange.value, data.enrolmentsData); as description) {
                        <li>
                          <span>{{ description.translationKey | translate: description.translationParams }}</span>
                        </li>
                      }
                    }
                  </ul>
                </sis-contextual-notification>
              </div>
            }
          </div>
          @if (!data.isLoading) {
            <div class="main-content col-12">
              <div class="row">
                @for (list of realisationLists; track list; let last = $last) {
                  <div class="col-12 col-lg-4 column-container">
                    @if (data.isMobileView) {
                      <sis-expandable
                        [title]="
                          list.titleKey | translate: { count: getEnrolmentsByType(data.enrolmentsData, list.enrolmentTypeKeys).length }
                        ">
                        <ng-template sisExpandableContent>
                          <app-enrolment-state-course-units
                            (handleCancelEnrolment)="handleCancelEnrolment($event)"
                            (handleEnrolment)="handleEnrolment($event)"
                            (handleRemoveEnrolment)="handleRemoveEnrolment($event)"
                            [emptyListText]="list.emptyListTextKey | translate"
                            [enrolments]="
                              getEnrolmentsByType(data.enrolmentsData, list.enrolmentTypeKeys)
                            "></app-enrolment-state-course-units>
                        </ng-template>
                      </sis-expandable>
                    } @else {
                      <app-enrolment-state-course-units
                        (handleCancelEnrolment)="handleCancelEnrolment($event)"
                        (handleEnrolment)="handleEnrolment($event)"
                        (handleRemoveEnrolment)="handleRemoveEnrolment($event)"
                        [emptyListText]="list.emptyListTextKey | translate"
                        [enrolments]="getEnrolmentsByType(data.enrolmentsData, list.enrolmentTypeKeys)"
                        [title]="
                          list.titleKey | translate: { count: getEnrolmentsByType(data.enrolmentsData, list.enrolmentTypeKeys).length }
                        "></app-enrolment-state-course-units>
                      @if (!last) {
                        <hr class="vertical-divider d-none d-md-block" aria-hidden="true" />
                      }
                    }
                  </div>
                }
              </div>
            </div>
          } @else {
            <div aria-busy="true" class="col-12 d-flex justify-content-center">
              <div class="spinner-border enrolment-spinner"></div>
            </div>
          }
        </div>
      }
    </div>
  }
</ng-container>
